import momentTZ, { Moment } from "moment-timezone";
import moment from "moment";

import "moment/locale/fr";
import "moment/locale/nl";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/it";
import "moment/locale/en-gb";

// Get the locale config type
interface LocaleConfig {
  _config: Record<string, unknown>;
}

export const setLocale = (locale: string, timezone: string): void => {
  moment.locale(locale); // apply it to moment

  momentTZ.defineLocale(locale, (moment.localeData() as unknown as LocaleConfig)._config); // copy locale to moment-timezone
  momentTZ.locale(locale); // apply it to moment-timezone

  momentTZ.tz.setDefault(timezone); // set timezone
};

// Re-export moment-timezone as default with proper type
export default momentTZ;

// Also export the Moment type for convenience
export type { Moment };
